import requireAuth from './requireAuth'
import withProject from './withProject'

const requireAuthAndProject = Component => requireAuth(withProject(Component))

export {default as authRoles} from './authRoles'
export {default as Auth} from './Auth'

export {requireAuth, withProject, requireAuthAndProject}



// WEBPACK FOOTER //
// ./src/auth/index.js